export const isEqual = (obj1 = {}, obj2 = {}) => {
  const keys = [
    'address.name',
    'saleAddressLifeCycle',
    'stageAddressLifeCycle',
    'stepAddressLifeCycle',
    'acceptanceStatusAddressLifeCycle',
  ];

  return keys?.every((key) => {
    const val1 = obj1[key];
    const val2 = obj2[key];

    if (Array.isArray(val1) && Array.isArray(val2)) {
      if (val1.length !== val2.length) return false;
      return val1.every((v, i) => v === val2[i]);
    }
    return val1 === val2;
  });
};
